import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import "../../assets/style/DeleteModal.css"; // Import the custom CSS

export default function PermissionMessage({ open, handleClose }) {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("usa-modal-overlay")) {
      handleClose();
    }
  };

  return (
    <div
      className="usa-modal-overlay"
      onClick={handleBackdropClick}
      aria-labelledby="modal-heading"
    >
      <div className="usa-modal-wrapper">
        <div className="usa-modal usa-modal-danger" role="dialog">
          <div className="usa-modal-header">
            <h2 className="usa-modal-heading" id="modal-heading">
              Access Denied
            </h2>
            <button
              className="usa-modal-close"
              aria-label="Close this modal"
              onClick={handleClose}
            >
              <span className="usa-sr-only">Close</span>
              <div className="usa-modal-close-icon"></div>
            </button>
          </div>

          <div className="usa-modal-content">
            <div className="usa-alert usa-alert-warning">
              <div className="usa-alert-body">
                <p>
                  {" "}
                  You don't have permission to perform this action. Please
                  contact // admin.
                </p>
              </div>
            </div>
          </div>

          <div className="usa-modal-footer">
            <button
              className="usa-button usa-button-outline"
              onClick={handleClose}
            >
              Cancel
            </button>
            {/* <button
              className="usa-button usa-button-danger"
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <span className="usa-spinner usa-spinner-small"></span>
                  <span>Processing...</span>
                </>
              ) : (
                "Yes, Delete"
              )}
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}
